import { Component } from '@angular/core';

@Component({
  selector: 'app-success-page',
  imports: [],
  templateUrl: './success-page.html',
  styleUrl: './success-page.scss',
})
export class SuccessPage {

}
